import { gql } from "@apollo/client";

export const CREATE_ASSET = gql`
  mutation CreateAsset($input: createAssetInput) {
    createAsset(input: $input) {
      Id
    }
  }
`;











export const GET_ASSET_BY_USERID = gql`
  query assetByUserId($userId: String) {
    assetByUserId(userId: $userId) {
      assetType
      assetStatus
      allocatedTo
      assetBrand
      issueDate
      assetId
      validTill
      assetValue
      returnedOn
      remarks
      imageUrl
      currentvalue
      warrantyPeriod
      endofLifeAsset
      billNo
    }
  }
`;
